export default __webpack_public_path__ + "static/allyOldDog-dd9f580188198289df17691bd3fa0e61.png";